import React, { useState } from "react";
import { BsEye } from "react-icons/bs";
import { Link, useNavigate } from "react-router";
const Dashboard = () => {
  const navigate=useNavigate()
  const schoolsData = [
    {
      schoolName: "Example School Name 1",
      inProgressActivities: 48,
      completedActivities: 32,
      gradedEssays: 180,
      feedbackRequests: 249,
      feedbackGiven: 482,
    },
    {
      schoolName: "Example School Name 2",
      inProgressActivities: 52,
      completedActivities: 30,
      gradedEssays: 190,
      feedbackRequests: 260,
      feedbackGiven: 500,
    },
    {
      schoolName: "Example School Name 3",
      inProgressActivities: 45,
      completedActivities: 28,
      gradedEssays: 175,
      feedbackRequests: 240,
      feedbackGiven: 470,
    },
    {
      schoolName: "Example School Name 4",
      inProgressActivities: 50,
      completedActivities: 35,
      gradedEssays: 200,
      feedbackRequests: 270,
      feedbackGiven: 510,
    },
    {
      schoolName: "Example School Name 5",
      inProgressActivities: 55,
      completedActivities: 33,
      gradedEssays: 185,
      feedbackRequests: 255,
      feedbackGiven: 490,
    },
    {
      schoolName: "Example School Name 6",
      inProgressActivities: 48,
      completedActivities: 32,
      gradedEssays: 180,
      feedbackRequests: 249,
      feedbackGiven: 482,
    },
    // {
    //   schoolName: "Example School Name 7",
    //   inProgressActivities: 53,
    //   completedActivities: 36,
    //   gradedEssays: 195,
    //   feedbackRequests: 265,
    //   feedbackGiven: 520
    // },
    // {
    //   schoolName: "Example School Name 8",
    //   inProgressActivities: 49,
    //   completedActivities: 31,
    //   gradedEssays: 182,
    //   feedbackRequests: 250,
    //   feedbackGiven: 485
    // },
    // {
    //   schoolName: "Example School Name 9",
    //   inProgressActivities: 47,
    //   completedActivities: 30,
    //   gradedEssays: 178,
    //   feedbackRequests: 245,
    //   feedbackGiven: 475
    // },
    // {
    //   schoolName: "Example School Name 10",
    //   inProgressActivities: 51,
    //   completedActivities: 34,
    //   gradedEssays: 192,
    //   feedbackRequests: 262,
    //   feedbackGiven: 505
    // }
  ];

  // console.log(schoolsData);
const [buttonType,setButtonType]=useState("dashboard")
  return (
    <div className="">
      <div className=" w-full flex flex-col p-8">
        <div className="flex items-center justify-between ">
          <div className="flex items-center gap-8">
          <button  onClick={()=>setButtonType("dashboard")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType==="dashboard"?"border border-blue-600 bg-gray-100 text-blue-600":"bg-blue-600 text-white"} `}>
            Dashboard
            </button>
          <Link to={"/admin/all-activities"} > <button onClick={()=>{
              setButtonType("allActivities");
              
            }}  className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType==="allActivities"?"border border-blue-600 bg-gray-100 text-blue-600":"bg-blue-600 text-white"} `}>
               All Activities
            </button></Link>
            
           <Link to={"/admin/email-templates"}> <button onClick={()=>setButtonType("emailTemplates")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType==="emailTemplates"?"border border-blue-600 bg-gray-100 text-blue-600":"bg-blue-600 text-white"} `}>
              Email Templates
            </button>
            </Link>
          <Link to={"/admin/schedule-activities"}> <button onClick={()=>setButtonType("scheduleActivities")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType==="scheduleActivities"?"border border-blue-600 bg-gray-100 text-blue-600":"bg-blue-600 text-white"} `}>
              Schedule Activities
            </button></Link> 
            <Link to={"/admin/manage-access/users"}> <button onClick={()=>setButtonType("users")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType==="users"?"border border-blue-600 bg-gray-100 text-blue-600":"bg-blue-600 text-white"} `}>
              Manage Access
            </button></Link> 
          </div>
       {buttonType==="dashboard" &&<div className="flex flex-row-reverse p-4 relative">
            {/* <img src={require('../../../assets/AIcon-08.png')} alt='' className="  w-8 h-8 text-gray-800 cursor-pointer " /> */}

            <select
              value={""}
              name=""
              id=""
              className=" right-[10px] outline-none text-[#71717A]  w-40 h-10 bg-white rounded-lg  border-2 border-spacing-2"
            >
              <option className="hover:bg-[#FEA769]" value="">
                Select Year
              </option>
              <option value="">2001</option>
              <option value="">2002</option>
              <option value="">2003</option>
            </select>
          </div>}
        </div>
        {/* details */}
        
        {buttonType==="dashboard"&& <div className="p-4"> <div className="w-full bg-r400 flex gap-8 items-center mt-8 relative ">
          <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
            Details
          </p>
          <div className="border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 text-nowrap">
            <div className="flex items-center gap-48">
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Total Schools</p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Regions</p>
                <p className="text-gray-700">4</p>
              </div>
            </div>
            <div className="flex items-center gap-14">
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Total Number of Supervisors</p>
                <p className="text-gray-700">128</p>
              </div>
              <div className="flex flex-col justify-center   text-[20px] ">
                <p className="text-gray-600">Total Number of School Heads</p>
                <p className="text-gray-700">4</p>
              </div>
            </div>
            <div className="flex items-center gap-[185px]">
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Total Subjects</p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Below Average Students</p>
                <p className="text-gray-700">4</p>
              </div>
            </div>
            <div className="flex items-center gap-[150px]">
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Average Students</p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-col justify-center  text-[20px] ">
                <p className="text-gray-600">Above Average Students</p>
                <p className="text-gray-700">4</p>
              </div>
            </div>
          </div>

          <div className="border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 relative">
            <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
              Submission Analytics
            </p>

            <div className="flex flex-col items-center gap-6">
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who received the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>{" "}
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who participated in the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who completed the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who didn’t started the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of submissions that have been graded:
                </p>
                <p className="text-gray-700">12</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white border-gray-400 rounded-lg border w-full mt-8 relative p-4">
          <p className="absolute bg-white text-2xl font-medium -top-8 left-8 p-2">
            School List
          </p>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="text-[16px] font-medium">
                <tr className="">
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    School Name
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    In-Progress Activities
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Completed Activities
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Graded Essays
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Feedback Requests
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Feedback Given
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Options
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-400">
                {schoolsData.map((school, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.schoolName}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.inProgressActivities}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.completedActivities}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.gradedEssays}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.feedbackRequests}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {school.feedbackGiven}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <button onClick={()=>navigate("/admin/school-details")} className=" flex items-center justify-center gap-1 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm">
                        <BsEye />
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        </div>}
      </div>
      {/* {buttonType==="allActivities"&&<AllActivities/>}
      {buttonType==="scheduleActivities"&&<ScheduleActivities/>}
      {buttonType==="emailTemplates"&&<EmailTemplates/>} */}


    </div>
  );
};

export default Dashboard;
